export var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["config"] = "ECDConfig";
    LocalStorageKeys["user"] = "ECDUser";
    LocalStorageKeys["theme"] = "ECDTheme";
    LocalStorageKeys["practitionerProfilePicture"] = "PractitionerProfilePicture";
    LocalStorageKeys["practitionerProgrammePicture"] = "PractitionerProgrammePicture";
    LocalStorageKeys["hasViewedJulProgressReport"] = "HasViewedJulProgressReport";
    LocalStorageKeys["hasViewedDecProgressReport"] = "HasViewedDecProgressReport";
    LocalStorageKeys["attendanceTutorialComplete"] = "AttendanceTutorialComplete";
    LocalStorageKeys["programmeWalkthroughComplete"] = "programmeWalkthroughComplete";
    LocalStorageKeys["hasClosedAttendanceSmartStartPointsMessage"] = "HasClosedAttendanceSmartStartPointsMessage";
    LocalStorageKeys["HasTrackedChildProgressBefore"] = "HasTrackedChildProgressBefore";
    LocalStorageKeys["isSmartStartUser"] = "IsSmartStartUser";
    LocalStorageKeys["coachProfilePicture"] = "CoachProfilePicture";
    LocalStorageKeys["hasClosedSuccessAttendanceSubmitted"] = "hasClosedSuccessAttendanceSubmitted";
    LocalStorageKeys["offlineStatments"] = "offlineStatments";
    LocalStorageKeys["childProfileTutorialComplete"] = "childProfileTutorialComplete";
    LocalStorageKeys["incomeStatementTutorialComplete"] = "IncomeStatementTutorialComplete";
    LocalStorageKeys["pointsSubmitStatementsMessageDismissed"] = "PointsSubmitStatementsMessageDismissed";
    LocalStorageKeys["askToJoinClubViewed"] = "AskToJoinClubViewed";
    LocalStorageKeys["hasVisitedProgrammeDashboard"] = "HasVisitedProgrammeDashboard";
})(LocalStorageKeys || (LocalStorageKeys = {}));
//# sourceMappingURL=local-storage-keys.js.map